import type { AdminMembershipDetail } from "@/types/admin-membership";
import type { MockUserId } from "@/lib/api/mock-data/users.mock";

export const MOCK_MEMBERSHIPS: Record<MockUserId, AdminMembershipDetail> = {
  u_001_alice_active: {
    membershipId: "m_001",
    userId: "u_001_alice_active",
    state: "active",
    path: "direct",
    futureBilling: "annual",
    trialStartedAt: null,
    trialEndsAt: null,
    conversionAt: "2024-08-12T10:20:00Z",
    commitmentEndsAt: "2027-08-12T10:20:00Z",
    pausedUntil: null,
    paymentMethodLast4: "4242",
    paymentMethodBrand: "visa",
    amountMinor: 84_000,
    currency: "SEK",
    nextBillingAt: "2026-08-12T10:20:00Z",
    failedPaymentCount: 0,
    pastDueSinceAt: null,
  },
  u_002_bob_trial_pending: {
    membershipId: "m_002",
    userId: "u_002_bob_trial_pending",
    state: "pending_delivery",
    path: "trial",
    futureBilling: "annual",
    trialStartedAt: "2026-05-14T08:03:00Z",
    trialEndsAt: "2026-06-13T08:03:00Z",
    conversionAt: null,
    commitmentEndsAt: null,
    pausedUntil: null,
    paymentMethodLast4: "0005",
    paymentMethodBrand: "mastercard",
    amountMinor: 84_000,
    currency: "SEK",
    nextBillingAt: "2026-06-13T08:03:00Z",
    failedPaymentCount: 0,
    pastDueSinceAt: null,
  },
  u_003_cara_trial_ending: {
    membershipId: "m_003",
    userId: "u_003_cara_trial_ending",
    state: "trial_ending_soon",
    path: "paid_trial",
    futureBilling: "monthly",
    trialStartedAt: "2026-04-28T14:51:00Z",
    trialEndsAt: "2026-05-28T14:51:00Z",
    conversionAt: null,
    commitmentEndsAt: null,
    pausedUntil: null,
    paymentMethodLast4: "1111",
    paymentMethodBrand: "amex",
    amountMinor: 9_900,
    currency: "NOK",
    nextBillingAt: "2026-05-28T14:51:00Z",
    failedPaymentCount: 0,
    pastDueSinceAt: null,
  },
  u_004_dave_card_failed: {
    membershipId: "m_004",
    userId: "u_004_dave_card_failed",
    state: "trial_card_failed",
    path: "trial",
    futureBilling: "annual",
    trialStartedAt: "2026-04-22T11:15:00Z",
    trialEndsAt: "2026-05-22T11:15:00Z",
    conversionAt: null,
    commitmentEndsAt: null,
    pausedUntil: null,
    paymentMethodLast4: "0341",
    paymentMethodBrand: "visa",
    amountMinor: 84_000,
    currency: "DKK",
    nextBillingAt: null,
    failedPaymentCount: 3,
    pastDueSinceAt: null,
  },
  u_005_erin_charged_off: {
    membershipId: "m_005",
    userId: "u_005_erin_charged_off",
    state: "trial_charged_off",
    path: "trial",
    futureBilling: "none",
    trialStartedAt: "2026-02-15T09:30:00Z",
    trialEndsAt: "2026-03-17T09:30:00Z",
    conversionAt: null,
    commitmentEndsAt: null,
    pausedUntil: null,
    paymentMethodLast4: "2244",
    paymentMethodBrand: "visa",
    amountMinor: 0,
    currency: "EUR",
    nextBillingAt: null,
    failedPaymentCount: 5,
    pastDueSinceAt: null,
  },
  u_006_finn_past_due: {
    membershipId: "m_006",
    userId: "u_006_finn_past_due",
    state: "past_due",
    path: "direct",
    futureBilling: "monthly",
    trialStartedAt: null,
    trialEndsAt: null,
    conversionAt: "2025-09-05T16:05:00Z",
    commitmentEndsAt: "2026-09-05T16:05:00Z",
    pausedUntil: null,
    paymentMethodLast4: "5454",
    paymentMethodBrand: "mastercard",
    amountMinor: 9_900,
    currency: "EUR",
    nextBillingAt: "2026-06-05T16:05:00Z",
    failedPaymentCount: 2,
    pastDueSinceAt: "2026-05-01T08:00:00Z",
  },
  u_007_gina_suspended: {
    membershipId: "m_007",
    userId: "u_007_gina_suspended",
    state: "suspended",
    path: "direct",
    futureBilling: "none",
    trialStartedAt: null,
    trialEndsAt: null,
    conversionAt: "2025-11-19T12:05:00Z",
    commitmentEndsAt: "2026-11-19T12:05:00Z",
    pausedUntil: null,
    paymentMethodLast4: "0017",
    paymentMethodBrand: "visa",
    amountMinor: 0,
    currency: "EUR",
    nextBillingAt: null,
    failedPaymentCount: 0,
    pastDueSinceAt: null,
  },
  u_008_hugo_cancelled: {
    membershipId: "m_008",
    userId: "u_008_hugo_cancelled",
    state: "cancelled",
    path: "direct",
    futureBilling: "none",
    trialStartedAt: null,
    trialEndsAt: null,
    conversionAt: "2024-12-01T09:05:00Z",
    commitmentEndsAt: "2026-12-01T09:05:00Z",
    pausedUntil: null,
    paymentMethodLast4: "9876",
    paymentMethodBrand: "visa",
    amountMinor: 0,
    currency: "SEK",
    nextBillingAt: null,
    failedPaymentCount: 0,
    pastDueSinceAt: null,
  },
};
